import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";
import { CrashFallback } from "./components/CrashFallback";

// Before render so boot-time crashes are captured too. No-op without a DSN.
initSentry();

// `<ClerkProvider>` lives in `src/auth/ClerkWithRouter.tsx` — it needs
// React Router's `useNavigate`, so it must mount inside <BrowserRouter>.

createRoot(document.getElementById("root")!).render(
  // Catches render-phase crashes that would otherwise blank the screen with
  // no signal anywhere (OPS-2026-002).
  <Sentry.ErrorBoundary fallback={<CrashFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
